import { memo } from 'react';

import { GizmoHelper, GizmoViewcube, GizmoViewport } from '@react-three/drei';
import { useStore } from '@spazious/dollhouse-store';
import { ControlsModeEnum } from '@spazious/dollhouse-types';

export interface HudProps {
  axes?: boolean;
  cube?: boolean;
}

export const Hud: React.FC<HudProps> = memo(({ axes = true, cube = true }) => {
  const controls = useStore(({ controls }) => controls);

  return (
    <group>
      {axes && controls === ControlsModeEnum.Orbit && (
        <GizmoHelper alignment="bottom-right" margin={[60, 80]} renderPriority={2}>
          <GizmoViewport axisColors={['#f93f3f', '#42b965', '#3f62f9']} labelColor="white" />
        </GizmoHelper>
      )}
      {cube && controls === ControlsModeEnum.Orbit && (
        <GizmoHelper alignment="top-right" margin={[60, 60]} renderPriority={3}>
          <GizmoViewcube />
        </GizmoHelper>
      )}
    </group>
  );
});
